import type { ReactNode } from 'react';

import { COOKIE_POLICY } from '#src/constants/__generated__/routes.ts';

export const LinkToCookiePolicy = (...s: ReactNode[]): ReactNode => {
  return <a href={COOKIE_POLICY}>{s}</a>;
};
